import { FC } from 'react'

export const Transmute: FC = () => {
  return <>Transmute</>
}
